import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import queryString from 'query-string';

import Layout from '../ui/Layout';
import Loading from '../ui/Loading';
import fetchDux from '../../state/fetch-dux';

class OurStory extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page: 'our-story',
      preview: qs.preview
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentWillUnmount() {
    this.props.clearGetContent();
  }
  render() {
    const { result, inProgress } = this.props;
    const { isPreview } = this.state;

    const { data, versionName } = result || {};
    return (
      <Layout route="our-story" isPreview={isPreview} versionName={versionName}>
        {inProgress && <Loading />}
        {!inProgress &&
          data &&
          <main>

            <section className="box-banner grape" />

            <Parallax offsetYMax={10} offsetYMin={-10} className="grape" />
            <Parallax
              offsetYMax={10}
              offsetYMin={-10}
              className="triangle"
              slowerScrollRate
            />

            <Grid>
              <Row>
                <Col sm={12}>

                  <Parallax offsetYMax={10} offsetYMin={-10} slowerScrollRate>
                    <section className="box-text">
                      <h2>{data.tagline}</h2>
                      <h1 style={{ whiteSpace: 'pre-wrap' }}>{data.title}</h1>
                      <p>{data.text}</p>
                    </section>
                  </Parallax>

                  {(data.biographies || []).map((biography, idx) => (
                    <section className="box-team" key={idx}>
                      <Parallax offsetYMax={10} offsetYMin={-10}>
                        <h2>{biography.name}</h2>
                        <h3>{biography.position}</h3>
                      </Parallax>
                      <Parallax
                        offsetYMax={10}
                        offsetYMin={-10}
                        slowerScrollRate
                      >
                        <div className="photo">
                          <div
                            style={{
                              backgroundImage: `url(${(biography.image || {}).href})`
                            }}
                          />
                        </div>
                      </Parallax>
                      <Parallax offsetYMax={6} offsetYMin={-6}>
                        <div className="quote">
                          {biography.description}
                        </div>
                      </Parallax>
                      <Row>
                        <Col md={6}>
                          <p>{biography.textLeft}</p>
                        </Col>
                        <Col md={6}>
                          <p>{biography.textRight}</p>
                        </Col>
                      </Row>
                    </section>
                  ))}
                </Col>
              </Row>
            </Grid>

            <section className="box-banner land" />

          </main>}
      </Layout>
    );
  }
}

const mapState = state => state.getContent.toJS();

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(OurStory);



// WEBPACK FOOTER //
// ./src/components/routes/OurStory.js